import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { DivBackgroundOpacity } from "@utils/extra-style";
import { GrayPara } from "../../EnquiryList.styled";

const Product = (props) => {
  const { t, data, isActive } = props;
  return (
    <>
      <DivBackgroundOpacity opacity={data?.isActive === 1 ? 1 : "0.2"}>
        {data.name}
        <GrayPara>
          {t(data.categoryName) + " - " + t(data.subCategoryName)}
        </GrayPara>
      </DivBackgroundOpacity>
    </>
  );
};

Product.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Product);
